export enum PerformanceTeamReviewStatusEnum {
    IN_PROGRESS = 'in_progress',
    COMPLETED = 'completed',
    UPCOMING = 'upcoming',
}
